import { graphql, readInlineData } from 'react-relay';
import { type getByDocCreator_item$key } from './__generated__/getByDocCreator_item.graphql';

const itemFragment = graphql`
    fragment getByDocCreator_item on Item @inline {
        creators {
            attribution
            creator {
                name
                displayName
            }
        }
    }
`;

type Props = {
    item: getByDocCreator_item$key | null | undefined;
};

export const getByDocCreator = ({ item: itemRef }: Props): string | null => {
    const item = readInlineData(itemFragment, itemRef);
    const byOrDocCreators = item?.creators?.find(
        creator => creator?.attribution === 'BY' || creator?.attribution === 'BY_AND_DOCUMENTED'
    );
    const byOrDocCreatorInfo = byOrDocCreators?.creator;
    return byOrDocCreatorInfo?.displayName || byOrDocCreatorInfo?.name || null;
};
